import { detectiOSARQuickLook } from '../../../core/static/js/helpers/utils.js'

export default class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this._swatches = JSON.parse(this.getAttribute('swatches'));
    this._images = JSON.parse(this.getAttribute('images'));
    this._group = {};
    this._style = null;
    this._type = null;
  }

  get swatches() {
    return this._swatches;
  }

  get images() {
    return this._images;
  }

  get group() {
    return this._group;
  }

  // called when a swatch is selected (or the first swatch is auto-selected)
  set group(val) {
    this._group = val;
    this.createCarousel();
  }
  get style() {
    return this._style;
  }

  set style(val) {
    this._style = val;
  }
  get type() {
    return this._type;
  }

  set type(val) {
    this._type = val;
  }

  static get observedAttributes() {
    return ['group', 'style'];
  }
  
  createCarousel() {  
    if (!this.group || !this.group.id) {
      // need to have a group selected
      return;
    }
    const swatch = this._swatches.find(swatch => (swatch.group === this.group.id && swatch.style === this.style));
    if (!swatch) {
      return;
    }
    const images = this._images[this.style][this.group.id];

    this.innerHTML = "";
    const productCarouselTemplate = document.createElement('template');
    productCarouselTemplate.setAttribute("id", "variant-hero");
    productCarouselTemplate.innerHTML = `
    <section class="carousal ${swatch.group} carousel-visibility" id="hero">
    ${
      images.map(image => {
        if (images.length == 1){
          const arEnabled = detectiOSARQuickLook();
          if ( this.type == 'mug' && arEnabled) {
            return `<a rel="ar" href="/core/static/images/mug/mug-ar.usdz" class="ghost-image">
	        <img src="/core/static/images/mug/ghost-image.png"/>
	        </a><div class="carousal-slide product-shot single-shot">
	        <img src="${image}"/>
	        </div>`
          }
          else {
            return `<div class="carousal-slide product-shot single-shot">
	        <img src="${image}"/>
	        </div>`
          }
      	}
      	else{
          if ( window.scrollY > 0 ){
            return `<div class="carousal-slide product-shot">
	        <img src="${image}"/>
	        </div>`
          } 
          else {
            return `<div class="carousal-slide product-shot peek">
	        <img src="${image}"/>
	        </div>`
          }
      	}
      }).join("")
    }
    </section>
    <a href="#" class="nav-button next"></a>
    <a href="#" class="nav-button previous"></a>`;
    this.appendChild(productCarouselTemplate.content.cloneNode(true));
    this.initCarousel();
  }

  initCarousel() {
    const carousel = document.querySelector('.product #hero.carousal');
    const NextBtn = document.querySelector('product-carousel .nav-button.next')
    const PrevBtn = document.querySelector('product-carousel .nav-button.previous')
    if (NextBtn){
      nextSlideEvent(NextBtn, carousel)
    }
    if (PrevBtn){
      previousSlideEvent(PrevBtn, carousel)
    }
    carousel.addEventListener('scroll', function () { 
      if ( carousel.scrollLeft > 0 ){
        removeSlideIndicator(carousel);
      }
    })
  }
}

var nextSlideEvent = function(el, carouselEl){
  el.addEventListener('click', function(event) {
    event.preventDefault();
    nextSlide(carouselEl)
    removeSlideIndicator(carouselEl);
  });
}

var previousSlideEvent = function(el, carouselEl){
  el.addEventListener('click', function(event) {
    event.preventDefault();
    previousSlide(carouselEl)
  });
}

var nextSlide = function (el){
  const carousel = el;
  const slides = el.querySelectorAll(".carousal .carousal-slide");
  const slideX = el.querySelector(".carousal .carousal-slide").clientWidth;
  const maxSlide = (slideX * slides.length) - slideX - slideX/2;
  if ( slides.length > 1){
    if ( carousel.scrollLeft > maxSlide ){
      carousel.scrollLeft = 0;
    } else {
      carousel.scrollLeft += slideX;
    }
  }
}

var previousSlide = function (el){
  const carousel = el;
  const slides = el.querySelectorAll(".carousal .carousal-slide");
  const slideX = el.querySelector(".carousal .carousal-slide").clientWidth;
  if ( slides.length > 1){
    carousel.scrollLeft -= slideX;
  }
}

var removeSlideIndicator = function (el){
  const slides = el.querySelectorAll(".carousal .carousal-slide");
  if ( slides.length > 1){
    for (let i = 0; i < slides.length; i++) {
      var slide = slides[i];
      slide.classList.remove('peek');
    }
  }
}

window.customElements.define('product-carousel', ProductCarousel);

window.addEventListener('resize', function () { //Resize Events
});

